import { render, staticRenderFns } from "./add_counsel_remark.vue?vue&type=template&id=96dc8124&scoped=true&"
import script from "./add_counsel_remark.vue?vue&type=script&lang=js&"
export * from "./add_counsel_remark.vue?vue&type=script&lang=js&"
import style0 from "./add_counsel_remark.vue?vue&type=style&index=0&id=96dc8124&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96dc8124",
  null
  
)

export default component.exports